// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/svg/select-arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile {
  margin-top: -1.11vw;
  margin-bottom: 1.67vw;
}

.profile h2 {
  font-weight: 400;
  font-size: 2.08125vw;
  color: #3a3a3a;
  line-height: 2.08125vw;
}

.profile .profile-tab {
  margin: 0.55vw 0 1.65vw 0;
}

.profile-info-form .spinner-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.profile-info-form .spinner-wrapper .spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, 50%);
}
.profile-info-form form {
  background-color: rgba(255, 255, 255, 0.8980392157);
  border-radius: 0.21vw;
  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);
  padding: 2.775vw 4.44vw 2.775vw 4.44vw;
  margin-top: 1.11vw;
  /* to change arrow fill color, add %23 infront of hex color */
}
.profile-info-form form .profile-info-container,
.profile-info-form form .profile-detail-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  justify-content: space-between;
  margin: 1.11vw 0;
}
.profile-info-form form .button-wrapper {
  text-align: end;
  width: calc(100% - 6.3825vw);
}
.profile-info-form form .button-wrapper button {
  font-size: 0.91vw;
  line-height: 1.25vw;
  font-weight: 500;
  margin: 1.11vw 0.2775vw;
  padding: 0.8325vw 2.22vw;
}
.profile-info-form form .button-wrapper button:nth-child(1) {
  color: #ee3a24;
  border: 1px solid #ee3a24;
  background-color: #fff;
  border-radius: 0.21vw;
  cursor: pointer;
}
.profile-info-form form .button-wrapper button:nth-child(2):disabled {
  background: rgba(77, 77, 77, 0.2);
  border: 1px solid rgba(77, 77, 77, 0.2);
  color: rgba(46, 46, 46, 0.6);
  cursor: default;
}
.profile-info-form form .button-wrapper button:nth-child(2) {
  background-color: #ee3a24;
  border: 1px solid #ee3a24;
  color: #fff;
  border-radius: 0.21vw;
  cursor: pointer;
}
.profile-info-form form .contact-info,
.profile-info-form form .profile-details {
  display: flex;
  align-items: center;
  justify-content: left;
}
.profile-info-form form .company-name {
  margin: 0 1.11vw;
}
.profile-info-form form .edit {
  text-align: end;
  position: relative;
  right: 6.66vw;
}
.profile-info-form form .contact-info .country-code {
  width: auto;
}
.profile-info-form form .contact-info .country-code select {
  width: 100%;
  margin-right: 2.5vw;
}
.profile-info-form form .profile-info-container div {
  width: calc(100% - 7.77vw);
}
.profile-info-form form .contact-info-container {
  width: 100% !important;
}
.profile-info-form form .mobile-number {
  width: 100% !important;
  margin-left: 0.555vw !important;
}
.profile-info-form form .profile-info-container input,
.profile-info-form form .contact-info-container input {
  width: 100%;
}
.profile-info-form form .profile-info-container select {
  width: calc(100% + 1.35vw);
  appearance: none;
}
.profile-info-form form .profile-info-container select {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-color: #fff;
}
.profile-info-form form .profile-info-container select {
  background-size: 0.754rem;
  background-position: calc(100% - 0.555vw) 1vw;
  background-repeat: no-repeat;
}
.profile-info-form form .profile-info-container select:disabled {
  cursor: default;
  background-color: light-dark(rgba(239, 239, 239, 0.3), rgba(59, 59, 59, 0.3));
  border: 1px solid var(--Grey, #737373);
  opacity: 1;
  font-size: 0.8325vw;
  font-weight: 400;
  line-height: 1.25vw;
  color: #616161;
}
.profile-info-form form .profile-info-form input:hover,
.profile-info-form form .profile-info-form select:hover {
  outline: none !important;
  box-shadow: none !important;
  border: 1px solid var(--Grey, #737373);
}
.profile-info-form form .profile-info-container input,
.profile-info-form form .profile-info-container select {
  border: 1px solid var(--Grey, #737373);
  padding: 0.555vw;
}
.profile-info-form form .profile-info-container input,
.profile-info-form form .profile-info-container select {
  font-weight: 400;
  font-size: 0.84vw;
  line-height: 1.25vw;
  color: #616161;
}
.profile-info-form form .profile-img {
  width: 5.02vw;
  height: 5.02vw;
  border-radius: 50%;
  box-shadow: 0 0 0.21vw gainsboro;
}
.profile-info-form form .profile-img .sb-avatar {
  width: 5.0296875vw !important;
  height: 5.0296875vw !important;
}
.profile-info-form form .profile-img .sb-avatar .sb-avatar__text {
  width: 5.0296875vw !important;
  height: 5.0296875vw !important;
}
.profile-info-form form .profile-img .sb-avatar .sb-avatar__text .sb-avatar__text div {
  font-size: 1.67vw !important;
}
.profile-info-form form label {
  display: block;
  margin-top: 0.555vw;
  margin-bottom: 0.18vw;
  color: #3a3a3a;
  font-weight: 400;
  line-height: 1.25vw;
  font-size: 0.92vw;
  letter-spacing: 2%;
}
.profile-info-form form .edit p {
  color: #ee3a24;
  font-weight: 400;
  line-height: 1.25vw;
  font-size: 0.92vw;
  letter-spacing: 2%;
}
.profile-info-form form .company-name p:nth-child(1) {
  color: #3a3a3a;
  font-weight: 500;
  line-height: 1.25vw;
  font-size: 1.05vw;
  letter-spacing: 2%;
}
.profile-info-form form .company-name p:nth-child(2) {
  color: #616161;
  font-weight: 400;
  line-height: 1.25vw;
  font-size: 0.84vw;
  letter-spacing: 2%;
}`, "",{"version":3,"sources":["webpack://./src/style/components/dashboard/Profile.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,qBAAA;AACF;;AACA;EACE,gBAAA;EACA,oBAAA;EACA,cAAA;EACA,sBAAA;AAEF;;AAAA;EACE,yBAAA;AAGF;;AACE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAEJ;AADI;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,+BAAA;AAGN;AAAE;EACE,mDAAA;EACA,qBAAA;EACA,+DAAA;EACA,sCAAA;EACA,kBAAA;EAyFA,6DAAA;AAtFJ;AAFI;;EAEE,aAAA;EACA,qCAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAIN;AAFI;EACE,eAAA;EACA,4BAAA;AAIN;AAFI;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,wBAAA;AAIN;AAFI;EACE,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;AAIN;AADI;EACE,iCAAA;EACA,uCAAA;EACA,4BAAA;EACA,eAAA;AAGN;AADI;EACE,yBAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;AAGN;AADI;;EAEE,aAAA;EACA,mBAAA;EACA,qBAAA;AAGN;AADI;EACE,gBAAA;AAGN;AADI;EACE,eAAA;EACA,kBAAA;EACA,aAAA;AAGN;AADI;EACE,WAAA;AAGN;AADI;EACE,WAAA;EACA,mBAAA;AAGN;AADI;EACE,0BAAA;AAGN;AADI;EACE,sBAAA;AAGN;AAAI;EACE,sBAAA;EACA,+BAAA;AAEN;AAAI;;EAEE,WAAA;AAEN;AACI;EACE,0BAAA;EAGA,gBAAA;AACN;AACI;EACE,6DAAA;EACA,sBAAA;AACN;AAGI;EACE,yBAAA;EACA,6CAAA;EACA,4BAAA;AADN;AAII;EACE,eAAA;EACA,6EAAA;EAKA,sCAAA;EAKA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAVN;AAYI;;EAEE,wBAAA;EACA,2BAAA;EACA,sCAAA;AAVN;AAaI;;EAEE,sCAAA;EACA,gBAAA;AAXN;AAaI;;EAEE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAXN;AAaI;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,gCAAA;AAXN;AAcM;EACE,6BAAA;EACA,8BAAA;AAZR;AAaQ;EACE,6BAAA;EACA,8BAAA;AAXV;AAYU;EACE,4BAAA;AAVZ;AAeI;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAbN;AAeI;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAbN;AAeI;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAbN;AAeI;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAbN","sourcesContent":[".profile {\n  margin-top: -1.11vw;\n  margin-bottom: 1.67vw;\n}\n.profile h2 {\n  font-weight: 400;\n  font-size: 2.08125vw;\n  color: #3a3a3a;\n  line-height: 2.08125vw;\n}\n.profile .profile-tab {\n  margin: 0.55vw 0 1.65vw 0;\n}\n\n.profile-info-form {\n  .spinner-wrapper {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    .spinner {\n      position: absolute;\n      left: 50%;\n      top: 50%;\n      transform: translate(-50%, 50%);\n    }\n  }\n  form {\n    background-color: #ffffffe5;\n    border-radius: 0.21vw;\n    box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);\n    padding: 2.775vw 4.44vw 2.775vw 4.44vw;\n    margin-top: 1.11vw;\n    .profile-info-container,\n    .profile-detail-container {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      align-items: center;\n      justify-content: space-between;\n      margin: 1.11vw 0;\n    }\n    .button-wrapper {\n      text-align: end;\n      width: calc(100% - 6.3825vw);\n    }\n    .button-wrapper button {\n      font-size: 0.91vw;\n      line-height: 1.25vw;\n      font-weight: 500;\n      margin: 1.11vw 0.2775vw;\n      padding: 0.8325vw 2.22vw;\n    }\n    .button-wrapper button:nth-child(1) {\n      color: #ee3a24;\n      border: 1px solid #ee3a24;\n      background-color: #fff;\n      border-radius: 0.21vw;\n      cursor: pointer;\n    }\n\n    .button-wrapper button:nth-child(2):disabled {\n      background: #4d4d4d33;\n      border: 1px solid #4d4d4d33;\n      color: #2e2e2e99;\n      cursor: default;\n    }\n    .button-wrapper button:nth-child(2) {\n      background-color: #ee3a24;\n      border: 1px solid #ee3a24;\n      color: #fff;\n      border-radius: 0.21vw;\n      cursor: pointer;\n    }\n    .contact-info,\n    .profile-details {\n      display: flex;\n      align-items: center;\n      justify-content: left;\n    }\n    .company-name {\n      margin: 0 1.11vw;\n    }\n    .edit {\n      text-align: end;\n      position: relative;\n      right: 6.66vw;\n    }\n    .contact-info .country-code {\n      width: auto;\n    }\n    .contact-info .country-code select {\n      width: 100%;\n      margin-right: 2.5vw;\n    }\n    .profile-info-container div {\n      width: calc(100% - 7.77vw);\n    }\n    .contact-info-container {\n      width: 100% !important;\n    }\n\n    .mobile-number {\n      width: 100% !important;\n      margin-left: 0.555vw !important;\n    }\n    .profile-info-container input,\n    .contact-info-container input {\n      width: 100%;\n    }\n\n    .profile-info-container select {\n      width: calc(100% + 1.35vw);\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n    }\n    .profile-info-container select {\n      background: url(\"../../../assets/svg/select-arrow.svg\") no-repeat;\n      background-color: #fff;\n    }\n\n    /* to change arrow fill color, add %23 infront of hex color */\n    .profile-info-container select {\n      background-size: 0.754rem;\n      background-position: calc(100% - 0.555vw) 1vw;\n      background-repeat: no-repeat;\n    }\n\n    .profile-info-container select:disabled {\n      cursor: default;\n      background-color: light-dark(\n        rgba(239, 239, 239, 0.3),\n        rgba(59, 59, 59, 0.3)\n      );\n      // color: light-dark(rgb(84, 84, 84), rgb(170, 170, 170));\n      border: 1px solid var(--Grey, #737373);\n      // background: rgba(239,239,239,0.3);\n      // border: 1px solid var(--Grey, #737373);\n      //   cursor: default;\n      // color: rgb(97, 97, 97);\n      opacity: 1;\n      font-size: 0.8325vw;\n      font-weight: 400;\n      line-height: 1.25vw;\n      color: #616161;\n    }\n    .profile-info-form input:hover,\n    .profile-info-form select:hover {\n      outline: none !important;\n      box-shadow: none !important;\n      border: 1px solid var(--Grey, #737373);\n    }\n\n    .profile-info-container input,\n    .profile-info-container select {\n      border: 1px solid var(--Grey, #737373);\n      padding: 0.555vw;\n    }\n    .profile-info-container input,\n    .profile-info-container select {\n      font-weight: 400;\n      font-size: 0.84vw;\n      line-height: 1.25vw;\n      color: #616161;\n    }\n    .profile-img {\n      width: 5.02vw;\n      height: 5.02vw;\n      border-radius: 50%;\n      box-shadow: 0 0 0.21vw gainsboro;\n    }\n    .profile-img {\n      .sb-avatar {\n        width: 5.0296875vw !important;\n        height: 5.0296875vw !important;\n        .sb-avatar__text {\n          width: 5.0296875vw !important;\n          height: 5.0296875vw !important;\n          .sb-avatar__text div {\n            font-size: 1.67vw !important;\n          }\n        }\n      }\n    }\n    label {\n      display: block;\n      margin-top: 0.555vw;\n      margin-bottom: 0.18vw;\n      color: #3a3a3a;\n      font-weight: 400;\n      line-height: 1.25vw;\n      font-size: 0.92vw;\n      letter-spacing: 2%;\n    }\n    .edit p {\n      color: #ee3a24;\n      font-weight: 400;\n      line-height: 1.25vw;\n      font-size: 0.92vw;\n      letter-spacing: 2%;\n    }\n    .company-name p:nth-child(1) {\n      color: #3a3a3a;\n      font-weight: 500;\n      line-height: 1.25vw;\n      font-size: 1.05vw;\n      letter-spacing: 2%;\n    }\n    .company-name p:nth-child(2) {\n      color: #616161;\n      font-weight: 400;\n      line-height: 1.25vw;\n      font-size: 0.84vw;\n      letter-spacing: 2%;\n    }\n  }\n}\n// @media only screen  and  (max-width: 500px) {\n\n//   .profile-info-form {\n//     form {\n//   .profile-details{\n// display: block;\n//   }\n//   .company-name {\n//     margin: 1rem 0;\n//     word-break: break-word;\n//     text-align: center;\n// }\n// .profile-img {\n// margin: auto;\n// }\n//   }\n// }\n// }\n\n// @media only screen  and  (max-width: 600px) {\n//   .profile{\n//     margin-left: 1rem;\n//      margin-right: 1rem;\n//   }\n// }\n// @media only screen and (min-width: 601px) and  (max-width: 768px) {\n//   .profile{\n//      margin-left: 1.5rem;\n//      margin-right: 1.5rem;\n//   }\n// }\n\n// @media only screen  and  (max-width: 575px) {\n\n//   .profile-info-form {\n//     form {\n//       margin-left: 0rem;\n//       padding: 2.5rem 2rem;\n\n//       .profile-detail-container{\n//     display: grid;\n//     grid-template-columns: repeat(1, 1fr);\n//   align-items: center;\n//   }\n//   .edit{\n//     right: 0rem;\n//   }\n// }\n//   }}\n//   @media only screen  and (min-width: 576px) and (max-width: 767px) {\n\n//     .profile-info-form {\n//       form {\n\n//     .edit{\n//       right: 0rem;\n//     }\n//   }\n//     }}\n// @media only screen  and  (max-width: 768px) {\n\n//   .profile-info-form {\n//     form {\n//       margin-left: 0rem;\n//       padding: 2.5rem 2rem;\n\n//       .profile-info-container{\n//     display: grid;\n//     grid-template-columns: repeat(1, 1fr);\n//   align-items: center;\n//   }\n//   .profile-info-container div{\n//     width: calc(100% - 1rem);\n//   }\n\n// }\n//   }\n// }\n\n// @media only screen  and  (min-width: 769px) and  (max-width: 1100px)  {\n\n//   .profile-info-form {\n//     form {\n//       margin-left: 0rem;\n//       padding: 2.5rem 2rem;\n\n//       .profile-info-container{\n//     display: grid;\n//     grid-template-columns: repeat(2, 1fr);\n//   align-items: center;\n//   }\n//   .profile-info-container div{\n//     width: calc(100% - 3rem);\n//   }\n//   .edit{\n//     right: 2.5rem;\n//   }\n// }\n//   }\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
